import { useQuery, UseQueryOptions } from 'react-query';
import {
  fetchHomePinsService,
  fetchHomesService,
  fetchHomeService,
} from 'src/api/homes';
import { HomeMapPin, HomesList, HomesListParams } from './types';

export function useFetchHomes(
  filters: HomesListParams,
  options?: UseQueryOptions<HomesList>,
) {
  const { isLoading, isFetching, data, error } = useQuery<HomesList>(
    ['homes', filters],
    () => fetchHomesService(filters),
    options,
  );
  return {
    isLoadingHomes: isLoading,
    isFetchingHomes: isFetching,
    homes: data,
    homesError: error,
  };
}

export const useHomePins = (
  filters: HomesListParams,
  options?: UseQueryOptions<HomeMapPin[]>,
) => {
  const { isLoading, error, data } = useQuery<HomeMapPin[]>(
    ['home-pins', filters],
    () => fetchHomePinsService(filters),
    options,
  );
  return {
    areHomePinsLoading: isLoading,
    homePins: data,
    homePinsErrors: error,
  };
};

export const useHome = (homeId?: string) => {
  const { isLoading, error, data } = useQuery(
    ['home', homeId],
    () => fetchHomeService(String(homeId)),
    { enabled: !!homeId },
  );
  return { isHomeLoading: isLoading, homeError: error, home: data };
};
